import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import {
    Spin, ConfigProvider
} from 'antd';
import getProjects from '../../ApiSeervice';
import { Color } from 'antd/es/color-picker';


const CATEGORIES = [
    { label: "All", value: "all" },
    { label: "Taahhüt", value: "Taahhüt" },
    { label: "Sanayi", value: "Sanayi" },
    { label: "Kentsel Dönüşüm", value: "Kentsel Dönüşüm" },
    { label: "Villa", value: "Villa" },
];

function TabProject() {
    const [projects, setProjects] = useState([]);
    const [loadedImages, setLoadedImages] = useState({});
    const [selectedCategory, setSelectedCategory] = useState("all");
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        function handleResize() {
            setIsMobile(window.innerWidth <= 600);
        }
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        async function fetchProjects() {
            const response = await getProjects();
            setProjects(response);
        }
        fetchProjects();
    }, []);

    const handleImageLoad = (id) => {
        setLoadedImages(prev => ({
            ...prev,
            [id]: true
        }));
    };

    // Filtrelenmiş projeler
    const filteredProjects = selectedCategory === "all"
        ? projects
        : projects.filter(p => p.type === selectedCategory);

    return (
        <div>
            {/* Kategori Butonları */}
            {isMobile ? (
                <div style={{ margin: '32px auto 24px auto', maxWidth: 320, textAlign: 'center' }}>
                    <select
                        value={selectedCategory}
                        onChange={e => setSelectedCategory(e.target.value)}
                        style={{
                            width: '100%',
                            padding: '8px 10px',
                            borderRadius: 4,
                            border: '1px solid #5c0a0a',
                            color: '#5c0a0a',
                            fontWeight: 'bold',
                        }}
                    >
                        {CATEGORIES.map(cat => (
                            <option key={cat.value} value={cat.value}>{cat.label}</option>
                        ))}
                    </select>
                </div>
            ) : (
                <div
                    style={{
                        marginTop: 32,
                        marginBottom: 24,
                        display: 'flex',
                        gap: 12,
                        flexWrap: 'wrap',
                        justifyContent: 'center',
                        marginLeft: 'auto',
                        marginRight: 'auto',
                    }}
                >
                    {CATEGORIES.map(cat => (
                        <button
                            key={cat.value}
                            onClick={() => setSelectedCategory(cat.value)}
                            style={{
                                background: selectedCategory === cat.value ? '#5c0a0a' : '#fff',
                                color: selectedCategory === cat.value ? '#fff' : '#5c0a0a',
                                border: '1px solid #5c0a0a',
                                borderRadius: 4,
                                padding: '4px 10px',
                                cursor: 'pointer',
                                fontWeight: selectedCategory === cat.value ? 'bold' : 'normal',
                                transition: 'all 0.2s',
                                minWidth: 80,
                                marginBottom: 8,
                            }}
                        >
                            {cat.label}
                        </button>
                    ))}
                </div>
            )}

            <div className="themesflat-project style-2 isotope-project has-margin mg15 data-effect clearfix">
                {filteredProjects.map(data => (
                    <div className="project-item architecture building construction" key={data.id}>
                        <div className="inner">
                            <div className="thumb data-effect-item has-effect-icon w40 offset-v-19 offset-h-49">
                                <ConfigProvider
                                    theme={{
                                        token: {
                                            colorPrimary: "#5c0a0a"
                                        },
                                    }}
                                >
                                    <Spin spinning={!loadedImages[data.id]} style={{ color: "#5c0a0a" }}>
                                        <img
                                            style={{
                                                height: "22vh",
                                                width: "100%",
                                                objectFit: "cover",
                                                display: loadedImages[data.id] ? 'block' : 'none'
                                            }}
                                            src={data.photos[0].path}
                                            alt="altimage"
                                            onLoad={() => handleImageLoad(data.id)}
                                            onError={() => handleImageLoad(data.id)}
                                        />
                                        {!loadedImages[data.id] && (
                                            <div style={{ height: "22vh", width: "100%" }} />
                                        )}
                                    </Spin>
                                </ConfigProvider>
                                <div className="elm-link" />
                                <div className="overlay-effect bg-color-3" />
                            </div>
                            <div className="text-wrap">
                                <h5 className="heading">
                                    <Link onClick={() => window.location.href = `/project-detail/${data.id}`}>
                                        {data.title}
                                    </Link>
                                </h5>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default TabProject;
